import { Injectable } from '@angular/core';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';

import { CountryService } from '../services/country.service';
import { StateService } from '../services/state.service';

export interface Addresses {
	folio: string; // DE000123
	active: boolean;
	city: string;
	countryId: string;
	createdAt: any;
	customerId: string;
	email: string;
	email2: string;
	externalNumber: string;
	internalNumber: string;
	mobile: string;
	municipality: string;
	neighborhood: string;
	phone: string;
	phone2: string;
	stateId: string;
	street: string;
	supplierId: string;
	typeId: string;
	updatedAt: any;
	zipCode: string;
	xlocality: string;
	xmunicipality: string;
	requiresCartaPorte: boolean; // Requiere Carta Porte además del CFDI de Traslado
}

export interface AddressId extends Addresses {
	id: string;
}

@Injectable()
export class AddressService {

	adresses$: Observable<any[]>;

	collection: string;

	constructor(
    private afh: FirestoreService,
    private countryService: CountryService,
    private stateService: StateService
	) {
		this.collection = Globals.ADDRESSES_COLLECTION;
	}

	getSupplierAddresses(supplierId: string) {
		return this.afh.colWithIds$(this.collection, ref => ref.where('supplierId', '==', supplierId).where('active', '==', true) );
	}
	getCustomerAddresses(customerId: string, {onEmpty=undefined}={}){
		return this.afh.colWithIds$(this.collection, ref => ref.where('customerId', '==', customerId).where('active', '==', true) ).map(ds => { if(!ds.length && onEmpty) onEmpty(); return ds; });
	}

	getAddresses(customerSupplierId: string, customerOrSupplier: string) {

    this.adresses$ = this.afh.colWithIds$(this.collection, ref => {
      return ref.where(customerOrSupplier, '==', customerSupplierId).where('active', '==', true) ;
    }).map(documents => {
      return documents.map(document => {
        const data = {
          id: document.id,
		  ...document,
          name: document.street + ", #" + document.externalNumber,
					zipCode: document.zipCode,
					municipality: document.municipality
        }
        return data;
      })
    })
    return this.adresses$;
}

	addAddress(addressData: any) {
    	return this.afh.add(this.collection, addressData);
	}

	getAddress(addressId: string) {
    	return this.afh.docWithIds$(`${this.collection}/${addressId}`);
	}

	updateAddress(id: string, addressData: any) {
    	this.afh.update(`${this.collection}/${id}`, addressData);
	}

	deleteAddress(id: string) {
		this.afh.delete(`${this.collection}/${id}`);
	}

}

/* class ADDRESS{
	active: boolean;
	city: string;
	countryId: string;
	createdAt: any;
	customerId: string;
	email: string;
	email2: string;
	externalNumber: string;
	internalNumber: string;
	mobile: string;
	municipality: string;
	neighborhood: string;
	phone: string;
	phone2: string;
	stateId: string;
	street: string;
	supplierId: string;
	typeId: number;
	updatedAt: any;
	zipCode: number;
	constructor(description, street, neighborhood, city, stateName, zipCode, phone, phone2, internalNumber){
		this.active = true;
		this.city = city;
		this.countryId = '1';
		this.createdAt = new Date();
		this.customerId = '';// JSON.parse(localStorage.customersJson)[description];
		this.email = '';
		this.email2 = '';
		this.externalNumber = '';
		this.internalNumber = internalNumber;
		this.mobile = '';
		this.municipality = '';
		this.neighborhood = neighborhood;
		this.phone = phone;
		this.phone2 = phone2;
		this.stateId = states[stateName] || '999';
		this.street = street;
		this.supplierId = JSON.parse(localStorage.suppliersJson)[description];
		this.typeId = 1;
		this.updatedAt = this.createdAt;
		this.zipCode = zipCode;
	}
}
var states = {
	'Jal': '14',
	'DF': '9',
	'Mex': '15',
	'NL': '19',
	'Gua': '11',
	'Qro': '22'
} */